export default __webpack_public_path__ + "static/media/3dmodelOpacity_side2.58227e8c.png";